import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EnrollmentFormComponent } from './enrollment-form/enrollment-form.component';
import { ContactUsComponent } from './modules/contact-us/contact-us.component';
import { PrivacyPolicyComponent } from './modules/privacy-policy/privacy-policy.component';
import { TermsConditionComponent } from './modules/terms-condition/terms-condition.component';

const routes: Routes = [
  // { 
  //   path: '', 
  //   redirectTo: '/enrollment-form', 
  //   pathMatch: 'full'
  // },
  {
    path: '',
    component: EnrollmentFormComponent
  },
  { 
    path: 'enrollment-form', 
    component: EnrollmentFormComponent 
  },
  { 
    path: 'privacy-policy', 
    component: PrivacyPolicyComponent
  },
  { 
    path: 'terms-condition', 
    component: TermsConditionComponent
  },
  {
    path: 'contact-us',
    component: ContactUsComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
